module.exports = __webpack_public_path__ + "img/inventory-performance-dashboard.cecfb0a3.svg";